import { render, staticRenderFns } from "./ItemElementExpireDate.vue?vue&type=template&id=360f8c21&scoped=true"
import script from "./ItemElementExpireDate.vue?vue&type=script&lang=ts"
export * from "./ItemElementExpireDate.vue?vue&type=script&lang=ts"
import style0 from "./ItemElementExpireDate.vue?vue&type=style&index=0&id=360f8c21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360f8c21",
  null
  
)

export default component.exports